import $ from 'jquery';

export default class FullscreenFeatureGallery {
  constructor(config) {
    this._container = config.container;
    this._init();
  }

  _init() {
    var gallery = this._container;
    var _self = this;

    $(gallery).find('.slider').on('init', function() {
      _self._update();
    });
    $(gallery).find('.slider').on('beforeChange', function() {
      _self._update();
    });
    $(gallery).find('.slider').on('afterChange', function() {
      _self._update();
    });
  }

  _update() {
    var gallery = this._container;

    $(gallery).each(function() {
      var src = $(this).find('.slick-current .section__image img').attr('src');

      $(this).find('.section__block_content').each(function() {
        var block = $(this);
        var dataSrc = block.attr('data-src');

        if (dataSrc !== src) {
          block.find(':not(.global) .aos-init').removeClass('aos-animate');
          block.css('display', 'none');
        } else {
          block.css('display', 'flex');
          setTimeout(function() {
            block.find(':not(.global) .aos-init').addClass('aos-animate');
          }, 100);
        }
      });
    });
  }
}
